import { API_URL } from '../config/env';
import { createBearerJsonClient } from './apiFetchPolicy';

function createApi(token) {
  return createBearerJsonClient(token, { baseURL: API_URL });
}

function normalizeTrack(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const title = String(raw.title || '').trim();
  if (!title) return null;
  return {
    id: String(raw.id || ''),
    title,
    artist: String(raw.artist || '').trim(),
    url: String(raw.url || '').trim(),
    genre: String(raw.genre || '').trim(),
    duration: String(raw.duration || '').trim(),
    kind: String(raw.kind || '').trim(),
    sourceId: String(raw.sourceId || '').trim(),
    payload: raw.payload && typeof raw.payload === 'object' ? raw.payload : {},
  };
}

export function normalizeStudioPlaylists(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((p) => {
      if (!p || typeof p !== 'object') return null;
      const name = String(p.name || '').trim();
      if (!name) return null;
      const tracks = (Array.isArray(p.tracks) ? p.tracks : [])
        .map(normalizeTrack)
        .filter(Boolean);
      const now = new Date().toISOString();
      return {
        id: String(p.id || ''),
        name,
        description: String(p.description || '').trim(),
        regionId: String(p.regionId || '').trim(),
        tracks,
        createdAt: typeof p.createdAt === 'string' ? p.createdAt : now,
        updatedAt: typeof p.updatedAt === 'string' ? p.updatedAt : now,
      };
    })
    .filter(Boolean);
}

async function fetchPlaylists(api) {
  for (const path of ['/gallery/studio/playlists', '/auth/gallery/studio/playlists']) {
    try {
      const response = await api.get(path);
      return normalizeStudioPlaylists(response.data?.playlists);
    } catch (error) {
      if (error?.response?.status !== 404) throw error;
    }
  }
  return [];
}

async function savePlaylists(api, playlists) {
  const body = { playlists };
  for (const path of ['/gallery/studio/playlists', '/auth/gallery/studio/playlists']) {
    try {
      const response = await api.put(path, body);
      return normalizeStudioPlaylists(response.data?.playlists);
    } catch (error) {
      if (error?.response?.status !== 404) throw error;
    }
  }
  return normalizeStudioPlaylists(playlists);
}

export async function getStudioPlaylists(token) {
  if (!token) throw new Error('Authentication required');
  const api = createApi(token);
  return fetchPlaylists(api);
}

export async function updateStudioPlaylists(token, playlists) {
  if (!token) throw new Error('Authentication required');
  const api = createApi(token);
  return savePlaylists(api, playlists);
}
